import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import Update from "../table/Update";
import { Console } from "console";


const UpdateGroup = () =>{
    const navigate = useNavigate();
    const { Id } = useParams();
 
    const [data,setData] = useState<any>();
     console.log(Id);
  
     const initialData = {
      GroupName : data?.groupName,
     }
    useEffect(() => {
      const fetchDistributary = async () => {
        try {
          const response = await ApiService.axiosApi(`/group/${Id}`, {
            method: 'GET',
          });
  
          if (response.success) {
            setData(response.data)
          } else {
            toast.error("Failed to fetch group details");
          }
        } catch (error: any) {
          toast.error(error.message || "Failed to fetch group details");
          navigate(-1);
        }
      };
  
      if (Id) fetchDistributary();
    }, [Id]);
  
  
    const onSubmit = async (data: any) => {
      try {
        const updateData = {
         GroupName: data.GroupName,
        
        };
  
          const response = await ApiService.axiosApi(`/group/${Id}`, {
          method: 'PUT',
          data: updateData
        });
  
        if (response.success) {
          toast.success("Group updated successfully");
          navigate(-1);
        } else {
          toast.error(response.data.message || "Failed to update group");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to update group");
      }
    };
    return(
         <>
         <Update
       title = {'Update Group'}
       parentTitle={'Group'}
       
       fields ={
        [
          {
             name : "GroupName",
             label : "Group Name",
             type : "text"

          },
          
          
        ]
       }
       onSubmit = {onSubmit}
       initialData = {initialData}
       />

       
    </>
         
    )
}

export default UpdateGroup